import React, { useState } from 'react';
import { observer } from 'mobx-react';
import MarkdownContent from '../CompanyPage/MarkdownContent';
import EditWrapper from '../CompanyPage/EditWrapper';
import CompanyOfferings from '../../components/CompanyOfferings/CompanyOfferings';
import {
  PageWrapper, PageHeader, PageTitle, EditButton, Card, CardTitle,
  DownloadLink, EmptyState, TabBar, Tab, SubCard, SubCardTitle,
} from '../CompanyPage/CompanyPage.styles';

const SECTION_LABELS = [
  { key: 'differentiator', label: 'Differentiators' },
  { key: 'asks', label: 'Asks' },
  { key: 'qualifyingQuestions', label: 'Qualifying Questions' },
  { key: 'typicalObjections', label: 'Typical Objections' },
];

const OfferingsPage = observer(({ company, mode }) => {
  const [editing, setEditing] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const isReadonly = mode === 'readonly';
  const offerings = company?.offerings || [];

  if (editing) {
    return (
      <PageWrapper>
        <PageHeader>
          <PageTitle>Offerings</PageTitle>
        </PageHeader>
        <EditWrapper onBack={() => setEditing(false)}>
          <CompanyOfferings company={company} />
        </EditWrapper>
      </PageWrapper>
    );
  }

  const activeOffering = offerings[activeIndex];

  return (
    <PageWrapper data-tour="offerings-page">
      <PageHeader>
        <PageTitle>Offerings</PageTitle>
        {!isReadonly && (
          <EditButton onClick={() => setEditing(true)}>
            {'\u270E'} Edit
          </EditButton>
        )}
      </PageHeader>

      {offerings.length === 0 ? (
        <EmptyState>No offerings have been added yet.</EmptyState>
      ) : (
        <>
          {offerings.length > 1 && (
            <TabBar>
              {offerings.map((item, i) => (
                <Tab
                  key={i}
                  $active={activeIndex === i}
                  onClick={() => setActiveIndex(i)}
                >
                  {item.offering || `Offering #${i + 1}`}
                </Tab>
              ))}
            </TabBar>
          )}

          {activeOffering && (
            <Card>
              <CardTitle style={{ marginBottom: 20 }}>
                {activeOffering.offering || `Offering #${activeIndex + 1}`}
              </CardTitle>

              {SECTION_LABELS.map(({ key, label }) => {
                const content = activeOffering[key];
                if (!content) return null;
                return (
                  <SubCard key={key} style={{ marginBottom: 16 }}>
                    <SubCardTitle>{label}</SubCardTitle>
                    <MarkdownContent markdown={content} />
                  </SubCard>
                );
              })}

              {activeOffering.uploadLink && (
                <div style={{ marginTop: 16 }}>
                  <DownloadLink href={activeOffering.uploadLink} target="_blank" rel="noopener noreferrer">
                    {'\u{1F4CE}'} Download Document
                  </DownloadLink>
                </div>
              )}
            </Card>
          )}
        </>
      )}
    </PageWrapper>
  );
});

export default OfferingsPage;
